export const PrematchTableType = {
  TABLE: 'table',
  GROUP_TABLE: 'group_table',
  KNOCKOUT: 'knockout',
} as const;
